<template>
  <div class="template">
    <div class="search">
      <div class="search-center">
        <div class="search-item">
          姓名：
          <Input clearable v-model="search.name" placeholder="请输入姓名" style="width: 150px; margin-left: 10px"></Input>
        </div>
        <div class="search-item">
          手机号：
          <Input clearable v-model="search.phone" placeholder="请输入手机号" style="width: 150px; margin-left: 10px"></Input>
        </div>
        <div class="search-item">
          状态：
          <Select clearable v-model="search.status" placeholder="请选择" style="width: 120px; margin-left: 10px">
            <Option value="0">正常</Option>
            <Option value="1">停用</Option>
          </Select>
        </div>
        <div class="search-item">
          <Button type="primary" @click="handleSearch">查询</Button>
          <Button @click="handleReset" style="margin-left: 8px">重置</Button>
        </div>
      </div>
    </div>
    <div class="operation">
      <Button type="primary" @click="handleAdd">新增</Button>
      <Button type="error" @click="handleDelete" :disabled="selectList.length === 0" style="margin-left: 8px">删除</Button>
    </div>
    <div class="table">
      <Table :columns="columns" :data="tableList" @on-selection-change="handleSelectionChange">
        <template slot-scope="{ row }" slot="gender">
          {{ row.gender === '0' ? '男' : row.gender === '1' ? '女' : '-' }}
        </template>
        <template slot-scope="{ row }" slot="status">
          <Tag :color="row.status === '0' ? 'green' : 'red'">{{ row.status === '0' ? '正常' : '停用' }}</Tag>
        </template>
        <template slot-scope="{ row }" slot="action">
          <Button type="primary" size="small" @click="handleEdit(row)">编辑</Button>
        </template>
      </Table>
      <div class="page">
        <Page 
          :total="total" 
          :current="page" 
          :page-size="limit" 
          :page-size-opts="[10, 20, 30, 50]"
          show-total 
          show-elevator 
          @on-change="handlePageChange"
          @on-page-size-change="handlePageSizeChange"
          show-sizer
        />
      </div>
    </div>

    <!-- 新增/编辑弹窗 -->
    <Modal
      v-model="modalVisible"
      :title="modalTitle"
      width="600"
      @on-ok="handleSubmit"
      @on-cancel="handleCancel"
    >
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" label-position="right" :label-width="100">
        <FormItem label="姓名" prop="name">
          <Input v-model="formValidate.name" placeholder="请输入姓名" />
        </FormItem>
        <FormItem label="手机号" prop="phone">
          <Input v-model="formValidate.phone" placeholder="请输入手机号" />
        </FormItem>
        <FormItem label="身份证号" prop="idCard">
          <Input v-model="formValidate.idCard" placeholder="请输入身份证号" />
        </FormItem>
        <FormItem label="性别" prop="gender">
          <RadioGroup v-model="formValidate.gender">
            <Radio label="0">男</Radio>
            <Radio label="1">女</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="工种/技能" prop="skill">
          <Input v-model="formValidate.skill" placeholder="请输入工种/技能" />
        </FormItem>
        <FormItem label="工作区域" prop="workArea">
          <Input v-model="formValidate.workArea" placeholder="请输入工作区域" />
        </FormItem>
        <FormItem label="状态" prop="status">
          <RadioGroup v-model="formValidate.status">
            <Radio label="0">正常</Radio>
            <Radio label="1">停用</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input v-model="formValidate.remark" type="textarea" :rows="3" placeholder="请输入备注" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import { installerList, addInstaller, updateInstaller, delInstaller } from '@/api/installer.js'

export default {
  name: 'installer',
  data() {
    return {
      search: {
        name: '',
        phone: '',
        status: ''
      },
      page: 1,
      limit: 10,
      total: 0,
      tableList: [],
      selectList: [],
      columns: [
        { type: 'selection', width: 60, align: 'center' },
        { title: 'ID', key: 'id', width: 80 },
        { title: '姓名', key: 'name', width: 120 },
        { title: '手机号', key: 'phone', width: 140 },
        { title: '身份证号', key: 'idCard', minWidth: 180, ellipsis: true, tooltip: true },
        { title: '性别', slot: 'gender', width: 80 },
        { title: '工种/技能', key: 'skill', width: 120 },
        { title: '工作区域', key: 'workArea', minWidth: 150, ellipsis: true, tooltip: true },
        { title: '状态', slot: 'status', width: 100 },
        { title: '备注', key: 'remark', minWidth: 150, ellipsis: true, tooltip: true },
        { title: '操作', slot: 'action', width: 100, fixed: 'right' }
      ],
      modalVisible: false,
      modalTitle: '新增安装工',
      isEdit: false,
      formValidate: {
        id: null,
        name: '',
        phone: '',
        idCard: '',
        gender: '0',
        skill: '',
        workArea: '',
        status: '0',
        remark: ''
      },
      ruleValidate: {
        name: [
          { required: true, message: '姓名不能为空', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '手机号不能为空', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
        ],
        idCard: [
          { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '身份证号格式不正确', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    // 加载数据
    loadData() {
      const params = {
        page: this.page,
        limit: this.limit,
        ...this.search
      }
      installerList(params).then(res => {
        if (res.code === 200) {
          const data = res.data
          this.tableList = data.records || []
          this.total = data.total || 0
        }
      })
    },
    // 搜索
    handleSearch() {
      this.page = 1
      this.loadData()
    },
    // 重置
    handleReset() {
      this.search = {
        name: '',
        phone: '',
        status: ''
      }
      this.handleSearch()
    },
    // 分页变化
    handlePageChange(page) {
      this.page = page
      this.loadData()
    },
    // 每页条数变化
    handlePageSizeChange(pageSize) {
      this.limit = pageSize
      this.page = 1
      this.loadData()
    },
    // 选择变化
    handleSelectionChange(selection) {
      this.selectList = selection
    },
    // 新增
    handleAdd() {
      this.modalTitle = '新增安装工'
      this.isEdit = false
      this.formValidate = {
        id: null,
        name: '',
        phone: '',
        idCard: '',
        gender: '0',
        skill: '',
        workArea: '',
        status: '0',
        remark: ''
      }
      this.modalVisible = true
      this.$nextTick(() => {
        this.$refs.formValidate && this.$refs.formValidate.resetFields()
      })
    },
    // 编辑
    handleEdit(row) {
      this.modalTitle = '编辑安装工'
      this.isEdit = true
      this.formValidate = {
        id: row.id,
        name: row.name || '',
        phone: row.phone || '',
        idCard: row.idCard || '',
        gender: row.gender || '0',
        skill: row.skill || '',
        workArea: row.workArea || '',
        status: row.status || '0',
        remark: row.remark || ''
      }
      this.modalVisible = true
    },
    // 取消
    handleCancel() {
      this.modalVisible = false
    },
    // 提交
    handleSubmit() {
      this.$refs.formValidate.validate((valid) => {
        if (valid) {
          const api = this.isEdit ? updateInstaller : addInstaller
          api(this.formValidate).then(res => {
            if (res.code === 200 || res.code === 0) {
              this.$Message.success(this.isEdit ? '修改成功' : '新增成功')
              this.modalVisible = false
              this.loadData()
            } else {
              this.$Message.error(res.msg || '操作失败')
            }
          })
        }
      })
    },
    // 删除
    handleDelete() {
      if (this.selectList.length === 0) {
        this.$Message.warning('请选择要删除的数据')
        return
      }
      this.$Modal.confirm({
        title: '提示',
        content: `确定要删除选中的 ${this.selectList.length} 条数据吗？`,
        onOk: () => {
          const ids = this.selectList.map(item => item.id)
          delInstaller(ids).then(res => {
            if (res.code === 200 || res.code === 0) {
              this.$Message.success('删除成功')
              this.loadData()
            } else {
              this.$Message.error(res.msg || '删除失败')
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.template {
  padding: 20px;
  
  .search {
    background: #fff;
    padding: 16px;
    margin-bottom: 16px;
    border-radius: 4px;
    
    .search-center {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;
      
      .search-item {
        display: flex;
        align-items: center;
      }
    }
  }
  
  .operation {
    margin-bottom: 16px;
  }
  
  .table {
    background: #fff;
    padding: 16px;
    border-radius: 4px;
    
    .page {
      margin-top: 16px;
      text-align: right;
    }
  }
}
</style>
